export default __webpack_public_path__ + "static/media/dr. Maria Endang Sumiwi, MPH.540f532b.webp";